export default __webpack_public_path__ + "images/e5c2807d0e7dedf4d6f5a31ef9eb3186-joint_icon.png";